import type { ComponentType } from "react";
import type { PricingPageComponentProps } from "../pricing-page.interface";

export type LazyPageLoader = () => Promise<{ default: ComponentType<PricingPageComponentProps> }>;

export const PRODUCT_PRICING_PAGE_MAP: Record<string, LazyPageLoader> = {
  "example-product": () =>
    import("../../../../lib/pricing-pages/example-product-pricing-page/example-product-pricing-page"),
  GITXXXTDPXX1: () => import("../../../../lib/pricing-pages/modello-730-pricing-page/Modello730PricingPage"),
  GITXXXTDFXX1: () => import("../../../../lib/pricing-pages/modello-730-pricing-page/Modello730PricingPage"),
  generic: () => import("../../../../lib/pricing-pages/monthly-removal-pricing-page/MonthlyRemovalPricingPage"),
};
